// @flow

import sharedDialogStyles from '../../Styles/SharedDialogStyles';

const addTenantDialogStyles = {
  // Import shared styles
  ...sharedDialogStyles,
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),

  dialogFormCtr: (theme) => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column'
  }),

  xlarge: (theme) => ({
    maxHeight: 450
  }),

  large: (theme) => ({
    maxHeight: 400
  }),

  normal: (theme) => ({}),

  grow: (theme) => ({
    flexGrow: 1,
    overflowY: 'visible'
  }),

  container: (theme) => ({
    position: 'relative'
  }),

  paper: (theme) => ({
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  }),

  inputRoot: (theme) => ({
    '& label + div': {
      marginTop: theme.spacing(3)
    }
  }),

  inputInput: (theme) => ({
    width: 'auto',
    flexGrow: 1
  }),

  secondInput: (theme) => ({
    marginTop: theme.spacing(2)
  }),

  largeTextField: (theme) => ({
    '& label': {
      transform: 'translate(20px, 24px) scale(1)'
    },
    '& textarea': {
      padding: theme.spacing(1)
    }
  }),

  messageTenantDialogTitle: (theme) => ({
    fontSize: '1rem',
    padding: '24px 24px 8px 24px'
  }),

  textFieldCaptionRight: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem',
    position: 'absolute',
    bottom: 20,
    right: 42
  }),

  warning: (theme) => ({
    color: theme.palette.error.main
  }),

  error: (theme) => ({
    color: theme.palette.status.error.main
  }),

  // phoneInputCtr removed - now using StyledPhoneInput component with integrated styling
};

export default addTenantDialogStyles;
